module.exports = __webpack_public_path__ + "img/browser-third.b8715e16.svg";